import "../Static Files/styles/rentacar/rentacar.css";
import heroimg from "../Static Files/Images/rentacar/Custom Size.png";
import location from "../Static Files/Images/rentacar/Location Icon 512x512.png";
import down from "../Static Files/Images/rentacar/Org down.png";
import up from "../Static Files/Images/rentacar/Org up.png";
import calendar from "../Static Files/Images/rentacar/Appointment Icon 512x512.png";
import key from "../Static Files/Images/rentacar/Car-key Icon 512x512.png";
import carrental from "../Static Files/Images/rentacar/Car Rental Software.webp";

const RentACar = () => {
  return (
    <main>
      <section className="rent-hero">
        <div className="texts-div">
          <h3>Avtomobil kiralayın</h3>
          <h1>
            Səyahətinizə <br />
            Rahatlıqla Başlayın <br /> Maşın İcarəsi
          </h1>
          <p className="header-p">
            Geniş avtomobil seçimimiz arasından ehtiyaclarınıza ən uyğun olanı
            seçin, sürətli və rahat təhvil prosesi ilə avtomobilinizi əldə edin
            və unudulmaz səyahətinizə başlayın !
          </p>
          <div className="learn-more">
            <a target="_blank" href="https://wa.me/994555074499">
              Ətraflı
            </a>
            <div className="phone-number">
              <h2>Daha çox məlumat üçün</h2>
              <p>(+99455) 507 44 99</p>
            </div>
          </div>
        </div>
        <img src={heroimg} alt="background-image" />
      </section>

      <section className="work-section">
        <h3>NECƏ İŞLƏYİR</h3>
        <h1>
          <span>Joyful</span> ilə 3 Addımda İcarə
        </h1>
        <div className="images-div">
          <div className="img-card">
            <div>
              <img src={location} alt="1" />
            </div>
            <h2>Yerləşmə seçin</h2>
            <p>İstədiyiniz yeri seçin və sizə uyğun avtomobilləri tapın.</p>
          </div>
          <div className="line">
            <img src={up} alt="1" />
          </div>
          <div className="img-card calendar">
          <div>
              <img src={calendar} alt="1" />
            </div>
            <h2>Götürmə tarixi</h2>
            <p>İcarə müddətini seçin və səyahətinizi planlayın.</p>
          </div>
          <div className="line">
            <img src={down} alt="1" />
          </div>
          <div className="img-card">
          <div>
              <img src={key} alt="1" />
            </div>
            <h2>Rezerv edin</h2>
            <p>Seçiminizi təsdiqləyin və yola çıxmağa hazır olun!</p>
          </div>
        </div>
      </section>

      <section className="companies-section">
        <img src={carrental} alt="rent" />
        <div className="texts-div">
          <h4>ŞİRKƏTLƏR</h4>
          <h1>
            <span>Joyful Travel</span> ilə Səyahətinizə Rəng Qatın Avtomobil
            icarəsi xidmətlərimiz
          </h1>
          <p>
            Səyahət etmək hər zaman xüsusi bir təcrübədir və Joyful Travel
            olaraq biz sizin yolculuğunuzu daha rahat və sərfəli etmək üçün
            müxtəlif avtomobil icarəsi şirkətləri ilə əməkdaşlıq edirik.
            İstədiyiniz ölkədə avtomobil icarəsi edərək təyinat yerinizə daha
            sürətli və rahat çatın. Bizim platformamız, sizə bir çox provayderin
            təkliflərini müqayisə edərək ən uyğun və sərfəli qiymətə ideal
            avtomobil seçməyə imkan verir. <br />
            <br /> Hər zaman şeffaf qiymət siyasəti ilə xidmət göstəririk. Bizim
            təklif etdiyimiz qiymətlərə bütün məcburi ödənişlər, vergilər və
            əlavə xərclər daxildir, beləliklə gözlənilməz sürprizlərlə
            qarşılaşmazsınız. Səyahətinizə başlamazdan əvvəl avtomobilinizi
            əvvəlcədən sifariş etmək, ən yaxşı mövcudluq və ən sərfəli
            qiymətləri əldə etmənizə kömək edəcək.
            <br />
            <br />
            Joyful Travel, fərqli avtomobil icarəsi şirkətləri ilə əməkdaşlıq
            edərək, səyahətinizin rahat, təhlükəsiz və əlverişli olmasını təmin
            edir. İstər iş, istər istirahət məqsədli olsun, avtomobil
            seçiminizlə rahat səyahət etməyə hazırsınız!
          </p>
        </div>
      </section>
    </main>
  );
};

export default RentACar;
